<template>
  <div :class="this.$styles.launcherMobileClass()">
    <div v-if="!chatWindowMaximized">
      <transition v-if="enableTransition" name="slideup" appear>
        <PopupLauncher
          :dealer-name="dealerName"
          :style="launcherContainer"
          class="chat-bubble-position"
        ></PopupLauncher>
      </transition>
      <template v-else>
        <PopupLauncher
          :dealer-name="dealerName"
          :style="launcherContainer"
          class="chat-bubble-position"
        ></PopupLauncher>
      </template>
    </div>
  </div>
</template>

<script>
import PopupLauncher from '../launchers/PopupLauncher.vue'

export default {
  components: {
    PopupLauncher,
  },
  data() {
    return {
      showMiniModal: true,
    }
  },
  created() {
    this.$events.triggerEvent('initialized-default-launcher')
  },
  computed: {
    launcherContainer() {
      return { ...this.$styles.launcherContainer(), ...{ 'z-index': this.popUpZIndex } }
    },
    miniModalStyles() {
      let bottomOffset = parseInt(this.launcherContainer.bottom) + 80
      return {
        bottom: `${bottomOffset}px`,
      }
    },
  },
  props: {
    dealerName: {
      type: String,
      default: '',
    },
    chatWindowMaximized: {
      type: Boolean,
      default: false,
    },
    enableTransition: {
      type: Boolean,
      default: true,
    },
    popUpZIndex: {
      type: Number,
      default: 99998,
    },
  },
  methods: {
    closeChat() {
      this.chatWindowMaximized = false
    },
    open() {
      this.$emit('open-chat')
      this.showMiniModal = false
    },
    chatClosed() {
      this.chatWindowMaximized = false
    },
    setupEventListeners() {
      this.$events.addEventListener('chat-closed', this.chatClosed)
    },
  },
}
</script>

<style scoped>
.chat-bubble-position {
  position: fixed;
  right: 25px;
}
.slideup-enter {
  transform: translateY(400px);
}
.slideup-enter-active,
.slideup-leave-active {
  transition: all 1s ease;
}
.slideup-leave-to {
  transform: translateY(0);
}
.fadein-enter-active {
  transition: all 3s ease;
  transition-delay: 5s;
}
.fadein-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fadein-enter,
.fadein-leave-to {
  opacity: 0;
}
.fadein-bubbleIcon-enter-active {
  transition: all 1s ease;
  transition-delay: 1s;
}
.fadein-bubbleIcon-leave-active {
  transition: all 1s ease;
}
.fadein-bubbleIcon-enter,
.fadein-bubbleIcon-leave-to {
  opacity: 0;
}

@media screen and (max-width: 850px) {
  .mobile-hide {
    display: none;
  }
}
</style>
